module.exports = __webpack_public_path__ + "media/assets/images/pq2_old-219f44b1005417fb91678c64b8423e94.svg";